module.exports = __webpack_public_path__ + "img/img3.8157c635.png";